import { Redirect } from 'expo-router'
import { type FC, type ReactNode } from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'

import { type RestrictedStatusGuardQuery } from '@/__generated__/RestrictedStatusGuardQuery.graphql'

export interface RestrictedStatusGuardProps {
  children: ReactNode
}

// confines users whose account status restricts app access (banned/appealing/inactive) to their dedicated screen,
// regardless of which route they navigate or deep-link to. mirrors the entry routing in UserRedirectScreen.
export const RestrictedStatusGuard: FC<RestrictedStatusGuardProps> = ({ children }) => {
  const queryData = useLazyLoadQuery<RestrictedStatusGuardQuery>(
    graphql`
      query RestrictedStatusGuardQuery {
        currentUser {
          status
        }
      }
    `,
    {}
  )

  const status = queryData?.currentUser?.status

  if (status === 'BANNED' || status === 'APPEAL') {
    return <Redirect href='/banned' />
  }

  if (status === 'INACTIVE' || status === 'SCHEDULED_FOR_DELETION') {
    return <Redirect href='/account-inactive' />
  }

  return <>{children}</>
}
